import html from '../legacy/py.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Python() {
  return <LegacyHtmlPage slug="py" title="Python · Advanced Topics" html={html} />;
}
